import React, { useState, useMemo } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import { ListItem } from "../../../common/ListItem";
// import { MasonryGrid } from "../../../common/MasonryGrid/MasonryGrid";
import { MasonryGrid } from "../../../common/MasonryGrid";

import { TagCard } from "../../../common/TagCard";
import * as styles from "./TagPage.module.scss";
import { shuffle } from "../../../../utils/common";

const TagPage = ({ tagItems, title }) => {
  const limitTags = (tags, limit) => {
    const arr = tags.sort((a, b) => {
      if (a.text < b.text) {
        return -1;
      }
      if (a.text > b.text) {
        return 1;
      }
      return 0;
    });
    return arr
      .filter((item) => {
        return item.text !== title;
      })
      .splice(0, limit);
  };

  const VIEWS = {
    PROJECTS: "projects",
    STUDENTS: "students",
    ALL: "all",
  };
  const [currentView] = useState(VIEWS.ALL);

  const filteredTagItems = useMemo(() => {
    let arr = [];

    for (let i = 0; i < tagItems.length; i++) {
      if (currentView === VIEWS.ALL) {
        arr.push(tagItems[i]);
      }

      if (currentView === VIEWS.PROJECTS && tagItems[i].label === "Project") {
        arr.push(tagItems[i]);
      }

      if (currentView === VIEWS.STUDENTS && tagItems[i].label === "Student") {
        arr.push(tagItems[i]);
      }
    }

    return shuffle(arr);
  }, [currentView, tagItems, VIEWS.ALL, VIEWS.PROJECTS, VIEWS.STUDENTS]);

  return (
    <>
      {title && (
        <ListItem
          topBorder={true}
          leftBorder={false}
          rightBorder={false}
          size="large"
          tagName="h1"
        >
          Tag Results: {title}
        </ListItem>
      )}
      {/* <StandardGrid
        padded
        total={1}
        desktopTotal={1}
        className={styles.optionsTypeOrder}
      >
        <div
          className={classNames(styles.optionsLabel, styles.optionsLabelOrder)}
        >
          Filter Results by
        </div>
        <div>
          <Button
            className={classNames(styles.optionsBtn, {
              [styles.active]: currentView === VIEWS.PROJECTS,
            })}
            onClick={() => {
              setCurrentView(VIEWS.PROJECTS);
            }}
          >
            Projects
          </Button>
          <Button
            className={classNames(styles.optionsBtn, {
              [styles.active]: currentView === VIEWS.STUDENTS,
            })}
            onClick={() => {
              setCurrentView(VIEWS.STUDENTS);
            }}
          >
            Students
          </Button>
          <Button
            className={classNames(styles.optionsBtn, {
              [styles.active]: currentView === VIEWS.ALL,
            })}
            onClick={() => {
              setCurrentView(VIEWS.ALL);
            }}
          >
            All
          </Button>
        </div>
      </StandardGrid> */}
      <div className={styles.outer}>
        <MasonryGrid isFull>
          {filteredTagItems.map((item, index) => {
            const tags = limitTags(item.tags, 20);
            return (
              <TagCard
                explicit={item.explicit}
                className={classNames(styles.item, [styles[item.type]])}
                key={index}
                imageTabs={item.label ? [{ text: item.label }] : null}
                tags={tags}
                sanityImage={item.sanityImage}
                cloudinaryImage={item.image}
                to={item.to}
                alt={item.alt || item.displayName + " - " + item.title}
                itemSlug={item.slug}
              ></TagCard>
            );
          })}
        </MasonryGrid>
      </div>
    </>
  );
};

TagPage.propTypes = {
  tagName: PropTypes.string,
};

export { TagPage };
